import React, { useState } from 'react';
import { Button, Card, Col, Dropdown, DropdownButton, Container, Row} from "react-bootstrap";
import { axiosAuth_DATA_MGMT_API } from '../utils/AxoisUtilComponent';
import { useTranslation } from 'react-i18next';
import classes from './AdminPages.module.css';
import { translateAPIError } from '../utils/apiUtils';
import { testJSON } from '../utils/jsUtils';


const ActionAdmin_NewActionView = (props) => {

  // Utilities
  const { t } = useTranslation(['common', 'custom']);

  // Initialize with actual JSON obj.  If not, will get error.
  const [actionAttrs, setActionAttrs] = useState({
    id: '',
    name: '',
    description: '',
    type: '',
    config: '{}',
    status: ''
  });

  const typeOptions = [
    { key: "ACT_TYPE_SEND_NOTIF",  value: "ACT_TYPE_SEND_NOTIF" },
    { key: "ACT_TYPE_CREATE_WO",   value: "ACT_TYPE_CREATE_WO" }
  ];

  const statusOptions = [
    { key: "ST_ENABLED",  value: "ST_ENABLED" },
    { key: "ST_DISABLED", value: "ST_DISABLED" }
  ];


  // UI Functions

  const [errMsg, setErrMsg] = useState('');

  const onAttrsInputChange = (e) => {
    setActionAttrs({ ...actionAttrs, [e.target.name]: e.target.value })
  }

  const onTypeSelect = (key, event) => {
    setActionAttrs({ ...actionAttrs, type: key });
  }

  const onStatusSelect = (key, event) => {
    setActionAttrs({ ...actionAttrs, status: key });
  }

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!actionAttrs.name || actionAttrs.name.trim().length === 0) {
      setErrMsg(t("I18N_ERR_Need_name"));
    } else {
      validateName();
    }

    return;
  }

  // Since this is async, need to call this first, and check the others when username availability returns
  function validateName() {

    new Promise(async (resolve, reject) => {
      try {
        const res = await axiosAuth_DATA_MGMT_API.get("actions?name=" + actionAttrs.name);

        resolve(res.data);

        if ((res.status === 200) && (res.data.length > 0)) {
          // Action name is taken
          setErrMsg(t("I18N_ERR_Name_taken"));
          return;
        } else {
          validateOtherFields();
          return;
        }
      } catch (error) {
        if (!error.message || (error.message !== 'IGNORE')) {
          setErrMsg(t(translateAPIError(error)));
          validateOtherFields();
        }
        return;
      }
    });
  }

  function validateOtherFields() {

    // Validate form inputs
    if (actionAttrs.name.length > 100) {
      setErrMsg(t("I18N_ERR_Max_len_name") + 100);
      return;
    } else if (!actionAttrs.description || actionAttrs.description.trim().length === 0) {
      setErrMsg(t("I18N_ERR_Need_description"));
      return;
    } else if (actionAttrs.description.length > 200) {
      setErrMsg(t("I18N_ERR_Max_len_desc") + 200);
      return;
    } else if (!actionAttrs.type || actionAttrs.type.length === 0) {
      setErrMsg(t("I18N_ERR_Need_type"));
      return;
    } else if (!actionAttrs.status || actionAttrs.status.length === 0) {
      setErrMsg(t("I18N_ERR_Need_status"));
      return;
    } else if (   actionAttrs.config
               && (actionAttrs.config !== '')
               && (!testJSON(actionAttrs.config.trim()))) {
      // Validate configuration to be valid JSON
      setErrMsg(t("I18N_ERR_Config_need_valid_JSON"));
      return;
    }

    createNewAction();
  }

  const createNewAction = () => {

    // Make a deep copy
    const reqBody = JSON.parse(JSON.stringify(actionAttrs));

    if ((actionAttrs.config == null) || (actionAttrs.config === '')) {
      reqBody.config = null;
    } else {
      reqBody.config = JSON.parse(actionAttrs.config.trim());
    }

    return new Promise(async (resolve, reject) => {
      try {
        const res = await axiosAuth_DATA_MGMT_API.post("actions", reqBody);

        resolve(res.data);

        if (res.status === 201) {

          // Return to list
          props.onUIMode('LIST')
          setErrMsg('');
        }
      } catch (error) {
        if (!error.message || (error.message !== 'IGNORE')) {
          setErrMsg(t(translateAPIError(error)));
        }
      }
    });
  }


  const handleCancel = (e) => {
    e.preventDefault();

    // Return to list
    props.onUIMode('LIST')
  }


  return (
    <>
      <Card style={{overflow:'auto', border:'0', boxShadow:'0 2px 2px 0px rgba(0,0,0,0.1)',
                    padding:'20px 40px 20px 40px', maxWidth:'2500px', width:'100%', fontSize:'13px'}}>

        <div style={{display:'flex'}}>
        <span className={classes.admin_pages__page_title}>
          {t("I18N_New_Action")}
        </span>
        </div>

        <div className={classes.admin_pages__page_subtitle} style={{marginTop:'20px'}}>
          <div display='flex'>
            <span>
              {t("I18N_Action_info")}
            </span>
          </div>
          <hr className="solid" style={{ margin: '0 0 10px 0' }}></hr>
        </div>

        <Container>
          <form>
            <Row className={classes.admin_pages__field_label}>
              <Col md={3}>{t("I18N_Name")}: *</Col>
              <Col md={3}>{t("I18N_Description")}: *</Col>
              <Col md={3}>{t("I18N_Type")} *:</Col>
              <Col md={3}>{t("I18N_Status")}: *</Col>
            </Row>
            <Row className={classes.admin_pages__field_value}>
              <Col md={3}>
                <textarea className={classes.admin_pages__field_editable} style={{width:'100%'}} name="name" value={actionAttrs.name}
                  onChange={(e) => onAttrsInputChange(e)} />
              </Col>
              <Col md={3}>
                <textarea className={classes.admin_pages__field_editable} style={{width:'100%'}} name="description" value={actionAttrs.description}
                  onChange={(e) => onAttrsInputChange(e)} />
              </Col>
              <Col md={3}>
                <DropdownButton size="tiny_dropdown" variant="outline-secondary" id="dropdown-basic-button"
                  title={!actionAttrs.type ? t("common:I18N_DROPDOWN_PROMPT") :
                          t("I18N_" + (typeOptions.find( ({ key }) => key === actionAttrs.type )).value)}
                  onSelect={onTypeSelect}>
                  {typeOptions.map((item, index) => {
                    return (
                      <Dropdown.Item key={index} eventKey={item.key} className={classes.dropdown_item_wrap}>
                        {t("I18N_" + item.value)}
                      </Dropdown.Item>
                    );
                  })}
                </DropdownButton>
              </Col>
              <Col md={3}>
                <DropdownButton size="tiny_dropdown" variant="outline-secondary" id="dropdown-basic-button"
                  title={!actionAttrs.status ? t("common:I18N_DROPDOWN_PROMPT") :
                          t("I18N_" + (statusOptions.find( ({ key }) => key === actionAttrs.status )).value)}
                  onSelect={onStatusSelect}>
                  {statusOptions.map((item, index) => {
                    return (
                      <Dropdown.Item key={index} eventKey={item.key} className={classes.dropdown_item_wrap}>
                        {t("I18N_" + item.value)}
                      </Dropdown.Item>
                    );
                  })}
                </DropdownButton>
              </Col>
            </Row>

            <Row className={classes.admin_pages__field_label} style={{ marginTop: '10px' }}>
              <Col sm={{span: 12}}>{t("I18N_Config")}:</Col>
            </Row>
            <Row className={classes.admin_pages__field_value}>
              <Col sm={{span: 12}}>
                <textarea rows={5} className={classes.admin_pages__field_editable} style={{minWidth: '100%'}} name="config"
                          value={actionAttrs.config} onChange={(e) => onAttrsInputChange(e)} />
              </Col>
            </Row>

            <hr className="solid" style={{ marginTop: '30px' }}></hr>

            <Row className={classes.admin_pages__field_label} style={{ marginTop: '10px', fontStyle: 'italic' }}>
              <span>{t("I18N_Req_fields")}</span>
            </Row>

            <Row>
              <div display='flex' style={{ marginTop: '15px' }}>
                <Button size="sm" variant="outline-secondary" className="mb-3"
                  style={{ float: 'left' }}
                  onClick={handleCancel}>
                  {t("I18N_Cancel")}
                </Button>
                <Button size="sm" variant="outline-secondary" className="mb-3"
                  style={{ marginLeft: '15px' }}
                  onClick={handleSubmit}>
                  {t("I18N_Submit")}
                </Button>
                <span className={classes.admin_pages__field_label} style={{ marginLeft: '30px', color: 'rgba(200,0,0)', verticalAlign: 'top' }}>
                  {errMsg}
                </span>
              </div>
            </Row>
          </form>
        </Container>

      </Card>
    </>
  );
}
 
export default ActionAdmin_NewActionView;
